import { render, staticRenderFns } from "./SystemUpdatesDetail.vue?vue&type=template&id=2fb9ca0b&scoped=true"
import script from "./SystemUpdatesDetail.vue?vue&type=script&lang=js"
export * from "./SystemUpdatesDetail.vue?vue&type=script&lang=js"
import style0 from "./SystemUpdatesDetail.vue?vue&type=style&index=0&id=2fb9ca0b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9ca0b",
  null
  
)

export default component.exports